import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { PermanentSaving, Beneficiary, ScheduleDate, Dictionary, Parameter, Employee, PeriodTypeEnum } from '@akiba/models_bimbo';
import { FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';

@Component({
  selector: 'app-ps-re-registration',
  templateUrl: './ps-re-registration.component.html',
  styleUrls: ['./ps-re-registration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsReRegistrationComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  permanentSaving = new PermanentSaving();

  formControlContributionAmount = new FormControl();
  formControlExtraordinaryPaymentsAdvanceBonus = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlAnnualPerformanceBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlProfitSharingPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlTargetBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlYearEndAndPerformanceBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);

  beneficiariesTitles = ['Primer Beneficiario', 'Segundo Beneficiario', 'Tercer Beneficiario', 'Cuarto Beneficiario', 'Quinto Beneficiario',
    'Sexto Beneficiario', 'Séptimo Beneficiario', 'Octavo Beneficiario', 'Noveno Beneficiario', 'Décimo Beneficiario'];

  beneficiariesPrefix = ['firstBeneficiary', 'secondBeneficiary', 'thirdBeneficiary', 'fourthBeneficiary', 'fifthBeneficiary',
    'sixthBeneficiary', 'seventhBeneficiary', 'eighthBeneficiary', 'ninthBeneficiary', 'tenthBeneficiary'];

  beneficiariesControls = new Array<Array<FormControl>>();

  appLogicSubs: Subscription;

  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private UI:UiService, private authService: AuthenticationService) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));


    const minOrOne = this.logicService.minContribution(this.currentEmployee) === 0 ? 1 : this.logicService.minContribution(this.currentEmployee);
    this.formControlContributionAmount.setValidators([Validators.required, this.customValidator(minOrOne, this.logicService.maxSavingContribution(this.currentEmployee))]);

    const obj = this.currentEmployee.permanentSavings.toAny();

    obj.contributionAmount = 0;
    obj.annualPerformanceBonusPercentage = 0;
    obj.profitSharingPercentage = 0;
    obj.targetBonusPercentage = 0;
    obj.yearEndAndPerformanceBonusPercentage = 0;
    obj.currentAmount = 0;
    obj.beneficiaries = {};

    this.permanentSaving = new PermanentSaving(obj);
    this.permanentSaving.beneficiaries.add('firstBeneficiary', new Beneficiary({ index: 0 }));

    this.permanentSaving.beneficiaries.values().forEach(element => {
      const f = [new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)])];
      f[0].setValue(element.names);
      f[1].setValue(element.firstLastName);
      f[2].setValue(element.secondLastName);
      f[3].setValue(element.relation);
      f[4].setValue(element.percentage);
      this.beneficiariesControls.push(f);
    });


  }


  ngOnInit() {


  }

  async validateExtras(): Promise<boolean> {

    let aMessage: string;
    if (this.logicService.shouldShowSavingExtras(this.currentEmployee) && (
      this.permanentSaving.annualPerformanceBonusPercentage < 0 ||
      this.permanentSaving.profitSharingPercentage < 0 ||
      this.permanentSaving.targetBonusPercentage < 0 ||
      this.permanentSaving.yearEndAndPerformanceBonusPercentage < 0) ||
      (this.currentEmployee.isVeabBonusActive && this.currentEmployee.isVeabBonusActive === true && this.permanentSaving.veabBonus < 0)
    ) {

      aMessage = 'Ninguna aportación extra puede ser menor al 0%';

    }

    if (this.permanentSaving.profitSharingPercentage > 100 ||
      this.permanentSaving.yearEndAndPerformanceBonusPercentage > 100) {

      aMessage = aMessage ? aMessage + '<br>Ninguna aportación extra puede ser mayor al 100%.' : 'Ninguna aportación extra puede ser mayor al 100%.';

    }

    if (this.logicService.shouldShowSavingExtras(this.currentEmployee) && (
      this.permanentSaving.annualPerformanceBonusPercentage > 100 ||
      this.permanentSaving.targetBonusPercentage > 100) ||
      (this.currentEmployee.isVeabBonusActive && this.currentEmployee.isVeabBonusActive === true && this.permanentSaving.veabBonus > 100)
    ) {

      aMessage = aMessage ? aMessage + '<br>Ninguna aportación extra puede ser mayor al 100%.' : 'Ninguna aportación extra puede ser mayor al 100%.';

    }

    if (aMessage) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: aMessage + '<br>Por favor verifica la información.',
          close: 'Aceptar'
        }
      });

      return false;

    }

    return true;

  }

  async validateAmount(): Promise<boolean> {

    if (!this.formControlContributionAmount.valid || this.permanentSaving.contributionAmount < 1) {

      let aMessage = 'Favor de validar el monto de la cuota a descontar.';
      if (this.permanentSaving.contributionAmount <= 0) {
        aMessage = 'El monto de la cuota a descontar debe de ser mayor a cero.';
      } else if (this.permanentSaving.contributionAmount < this.logicService.minContribution(this.currentEmployee)) {
        aMessage = 'El monto de la cuota a descontar debe de ser mayor al mínimo.';
      } else if (this.permanentSaving.contributionAmount > this.logicService.maxSavingContribution(this.currentEmployee)) {
        aMessage = 'El monto de la cuota a descontar debe de ser menor al máximo.';
      }

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: aMessage,
          close: 'Aceptar'
        }
      });

      return false;

    }

    return true;

  }

  async validateBeneficiaries(): Promise<boolean> {


    const validPercentage = this.beneficiariesControls.map(element => element[4].value ? Number(element[4].value) : 0).reduce((prev, next) => prev + next);
    let aMessage: string;

    if (validPercentage < 100) {
      aMessage = 'El porcentaje de los beneficiarios da un total menor al 100%.';
    } else if (validPercentage > 100) {
      aMessage = 'El porcentaje de los beneficiarios da un total mayor al 100%.';
    }

    const missingValues = this.beneficiariesControls.reduce((prev, next) => next ? prev.concat(next) : prev).some(element => {
      return !element.value ? true : false;
    });

    if (missingValues) {
      aMessage = aMessage ? aMessage + '<br>La información de los beneficiarios esta incompleta.' : 'La información de los beneficiarios esta incompleta.';
    }

    if (aMessage) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: aMessage + '<br>Por favor verifica la información.',
          close: 'Aceptar'
        }
      });

      return false;

    }

    return true;

  }

  async validateForm(): Promise<boolean> {


    return this.validateAmount().then((r) => {

      if (r === false) {
        return Promise.reject();
      }

      return this.validateExtras();

    }).then((r) => {

      if (r === false) {
        return Promise.reject();
      }

      return this.validateBeneficiaries();

    }).then((r) => {

      return r;

    }).catch(() => {
      return false;
    });

  }

  ////////////////////////////////////////////////////////

  get maxSavingContribution(): number {

    return this.logicService.maxSavingContribution(this.currentEmployee);

  }

  get minContribution(): number {


    return this.logicService.minContribution(this.currentEmployee);

  }

  async logPermanentLoanMovements() {
    //salvar en logs alta
    const withdraws: Array<any> = [];
    const date = new Date();

    const paramLogs = {
      employeeNumber: this.currentEmployee.workInformation.employeeNumber,
      modificationDate: date,
      withdraws: withdraws,
      registerFor: this.authService.authEmployee.uid,
      action: 'ps-re-registration'
    }
    await this.dataService.saveLogPermanentLoanMovements(paramLogs).catch(error => {
      console.log(error);
      return;
    });
  }
  ////////////////////////////////////////////////////////

  submitSubscription() {

    this.validateForm().then(valid => {

      if (!valid) {
        return;
      }

      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
        data: {
          message: '¿Deseas realizar la modificación de tu cuota de ahorro, así como las aportaciones extraordinarias y beneficiarios?',
          cancelButton: 'Cancelar',
          confirmButton: 'Aceptar'
        }
      });

      dialogConfirmation.afterClosed().subscribe(result => {

        if (result) {

          this.UI.showSpinner();
          this.permanentSaving.status = 'active';
          this.permanentSaving.active = true;

          this.beneficiariesControls.forEach((anArray, index) => {
            const dictionaryKey = this.beneficiariesPrefix[index];
            const beneficiary = this.permanentSaving.beneficiaries.item(dictionaryKey);
            beneficiary.names = anArray[0].value;
            beneficiary.firstLastName = anArray[1].value;
            beneficiary.secondLastName = anArray[2].value;
            beneficiary.relation = anArray[3].value;
            const p = anArray[4].value;
            beneficiary.percentage = p ? Number(p) : 0;
            this.permanentSaving.beneficiaries.add(dictionaryKey, beneficiary);
          });

          this.permanentSaving.periodID = this.permanentSavingParameter.parametersID;
          this.permanentSaving.employeeRef.employeeNumber = this.currentEmployee.workInformation.employeeNumber;

          const toObj = this.permanentSaving.toAny();
          this.logPermanentLoanMovements();
          this.dataService.updatePermanentSavings(this.currentEmployee.workInformation.employeeNumber, toObj).then(() => {

            this.UI.stopSpinner();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

            this.contentLocation.detailIndex = 0;

          });

        }

      });

    }).catch(error => {

      this.UI.stopSpinner();
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No fue posible realizar el registro, inténtelo mas tarde',
          close: 'Aceptar'
        }
      });

    });

  }

  cancel(tabIndex: number, detailIndex: number | null) {
    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.detailIndex = detailIndex;
        this.contentLocation.contentIndex = 0;
      }
    });
  }

  addBeneficiary() {

    const percentageSum = this.beneficiariesControls.map(element => element[4].value ? Number(element[4].value) : 0).reduce((prev, next) => prev + next);
    if (percentageSum > 0 && percentageSum < 100) {

      const percentageForNewControl = 100 - percentageSum;
      const newArray = [new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)])];
      newArray[4].setValue(percentageForNewControl);
      this.beneficiariesControls.push(newArray);
      const len = this.beneficiariesControls.length - 1;
      this.permanentSaving.beneficiaries.add(this.beneficiariesPrefix[len], new Beneficiary({ index: len }));

    } else if (percentageSum === 0) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que ingrese un porcentaje válido antes de añadir mas beneficiarios',
          close: 'Aceptar'
        }
      });

    } else {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El porcentaje total es igual o mayor al 100%, para añadir mas beneficiarios<br>modifique los porcentajes para que el total sea menor al 100%.',
          close: 'Aceptar'
        }
      });

    }

  }

  removeLastBeneficiary() {

    const len = this.beneficiariesControls.length - 1;
    const beneficiariesTitle = this.beneficiariesTitles[len];
    const deleteBeneficiary = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea eliminar el ' + beneficiariesTitle + ' ?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    deleteBeneficiary.afterClosed().subscribe(result => {
      if (result) {

        this.beneficiariesControls.pop();
        this.permanentSaving.beneficiaries.remove(this.beneficiariesPrefix[len]);

      }
    });

  }

  get currentScheduleDate(): ScheduleDate | null {
    const cpsp = this.permanentSavingParameter;
    const sd = cpsp ? cpsp.currentRegistrationScheduleDate : new ScheduleDate();
    return sd;
  }

  ////////////////////////////////////////////////////////

  currencyInputChanged(value: string) {

    const num = value.replace(/[$,]/g, '');
    const intValue = Number(num);
    return intValue;

  }

  customValidator(min: number, max: number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let result: any | null = null;

      if (!control.value) {
        return result;
      }

      const num = control.value ? control.value.replace(/[$,]/g, '') : 0;
      const intValue = Number(num);

      if (isNaN(intValue)) {
        result = { min: true };
      } else if (intValue < min) {
        result = { min: true };
      } else if (intValue > max) {
        result = { max: true };
      }

      return result;

    };

  }

  ////////////////////////////////////////////////////////


  ngOnDestroy(): void {
    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }
  }

}
